module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 151.46 70.16"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_4",
      "data-name": "Layer 4"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M116.6,0H36.86a35,35,0,0,1,0,69.72H116.6a34.86,34.86,0,0,0,34.86-34.86h0A34.86,34.86,0,0,0,116.6,0Z",
      "fill": "#d7d8d6"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "34.86",
      "cy": "35.31",
      "r": "34.86",
      "fill": "#515151"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M19.32,15.18c-2.35,0-2.14,2-2.14,7.07V47.68c0,9.5-.53,8.65,9,8.65h18.2c9.5,0,8.11.85,8.11-8.65V22.25c0-5.24.26-7.31-2.3-7.31",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "47.07",
      "y1": "12.79",
      "x2": "47.07",
      "y2": "17.21",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "40.9",
      "y1": "12.79",
      "x2": "40.9",
      "y2": "17.21",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.72",
      "y1": "12.79",
      "x2": "34.72",
      "y2": "17.21",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28.54",
      "y1": "12.79",
      "x2": "28.54",
      "y2": "17.21",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "22.36",
      "y1": "12.79",
      "x2": "22.36",
      "y2": "17.21",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  })]), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "32.53",
      "y1": "49.5",
      "x2": "47.23",
      "y2": "49.5",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.53",
      "y1": "40.68",
      "x2": "47.23",
      "y2": "40.68",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.53",
      "y1": "31.85",
      "x2": "47.23",
      "y2": "31.85",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "32.53",
      "y1": "23.03",
      "x2": "47.23",
      "y2": "23.03",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    attrs: {
      "points": "22.66 49.76 24.38 51.08 27.14 48.04",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22.66 40.93 24.38 42.26 27.14 39.22",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22.66 32.11 24.38 33.43 27.14 30.39",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22.66 23.28 24.38 24.61 27.14 21.57",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2.25"
    }
  })])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a893147","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/ListIconWithBackground.vue
// module id = 3004
// module chunks = 0